var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.99957L11.06 5.05957L8 8.1129L4.94 5.05957L4 5.99957L8 9.99957L12 5.99957Z",
    fill: "#D0004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownPrimaryIcon);
export default __webpack_public_path__ + "static/media/dropdown-primary-icon.ad830142a18ef45859c537fb003d8b39.svg";
export { ForwardRef as ReactComponent };